import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "form-dialog__title" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "开票信息")
], -1)
const _hoisted_2 = { class: "form-dialog__content" }

import {
  ref,
  defineModel,
  withDefaults,
  computed
} from 'vue';
import {
  BaseForm,
  BaseFormItem,
  BaseInput,
  BaseSelect,
  BaseDatePicker
} from 'xrk-components';
import { InvoiceApplyDTO } from '@V/invoice/src/data-source/types';
// import { useVModel } from '@vueuse/core';
import { ORDER_TYPE } from '@constants/order';
import { formatter } from '@/utils';
import { DetailType } from '@V/invoice/src/types';
// import appStore from '@/store';
// import { storeToRefs } from 'pinia';
import { StateType } from '@cTypes/order';


export default /*#__PURE__*/_defineComponent({
  __name: 'invoice-detail-dialog-info',
  props: /*#__PURE__*/_mergeModels({
    detailType: {},
    invoiceBusinessType: {}
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose }) {

const props = __props;
// const { info: userInfo } = storeToRefs(appStore.useUserStoreSetup);

const disabled = !(
  [2].includes(props.detailType) //  && userInfo.value.functionCode === 3
);

const formRef = ref(null);
const formData = _useModel<InvoiceApplyDTO>(__props, "modelValue");
const formRules = {
  // taskAt: [{ required: true, message: '请选择', trigger: 'change' }]
};

const isType7 = computed(() => props.invoiceBusinessType === 7);

__expose({
  validate: (...args: any) => formRef.value?.validate(...args)
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseForm), {
    ref_key: "formRef",
    ref: formRef,
    "label-position": "top",
    scrollToError: "",
    model: formData.value,
    rules: formRules
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(BaseFormItem), {
          label: "企业名称",
          prop: "aspName"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              class: "form-dialog__w280",
              type: "text",
              placeholder: "请输入",
              disabled: "",
              modelValue: formData.value.aspName || formData.value.supplierName
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "纳税识别号",
          prop: "invoiceIdentifierNo"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              class: "form-dialog__w280",
              type: "text",
              placeholder: "请输入",
              disabled: "",
              modelValue: formData.value.invoiceIdentifierNo
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "联系电话",
          prop: "invoicePhone"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              class: "form-dialog__w280",
              type: "tel",
              placeholder: "请输入",
              disabled: "",
              modelValue: formData.value.invoicePhone
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "开户银行",
          prop: "invoiceOpenBank"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              class: "form-dialog__w280",
              type: "text",
              placeholder: "请输入",
              disabled: "",
              modelValue: formData.value.invoiceOpenBank
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "银行账号",
          prop: "invoiceBankNo"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              class: "form-dialog__w280",
              type: "text",
              placeholder: "请输入",
              disabled: "",
              modelValue: formData.value.invoiceBankNo
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "企业地址",
          prop: "invoiceEnterpriseAddress"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              class: "form-dialog__w280",
              type: "text",
              placeholder: "请输入",
              disabled: "",
              modelValue: formData.value.invoiceEnterpriseAddress
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "发票类型",
          prop: "invoiceTypeName"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              class: "form-dialog__w280",
              type: "text",
              placeholder: "请输入",
              disabled: "",
              modelValue: formData.value.invoiceTypeName
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "发票类目",
          prop: "itemName"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              class: "form-dialog__w280",
              type: "text",
              placeholder: "请输入",
              disabled: "",
              modelValue: formData.value.itemName
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "订单类型",
          prop: "orderMixtureType"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseSelect), {
              class: "form-dialog__w280",
              type: "text",
              placeholder: "请输入",
              disabled: "",
              modelValue: formData.value.orderMixtureType,
              options: _unref(ORDER_TYPE)
            }, null, 8, ["modelValue", "options"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "价税合计",
          prop: "invoiceAmount"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              class: "form-dialog__w280",
              type: "text",
              placeholder: "请输入",
              disabled: "",
              modelValue: _unref(formatter).fen2yuan(formData.value.invoiceAmount)
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        (!isType7.value)
          ? (_openBlock(), _createBlock(_unref(BaseFormItem), {
              key: 0,
              label: "结算月度",
              prop: "taskAt"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseDatePicker), {
                  style: {"width":"100%"},
                  type: "month",
                  "validate-event": "",
                  disabled: disabled,
                  modelValue: formData.value.taskAt,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.taskAt) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["model"]))
}
}

})